export const bankList = {
  ACD: 'Accès Crédit',
  GML: 'ALLY\\RBC Commercial',
  AFS: 'ALPHERA Financial Services',
  ATB: 'ATB Financial',
  AFX: 'Audi Financing Ducati',
  ACP: 'AutoCapital Canada',
  AUP: 'Autonum Presto Leasing Inc',
  AAL: 'Axis Auto Leasing',
  BMO: 'Bank of Montreal',
  CPO: 'Caisse Alliance',
  CAI: 'Caisse Populaire',
  CDA: 'Canadian National Auto Loan',
  CTO: 'Canadian Title Loan Corporation',
  CAR: 'CARFINCO',
  CRC: 'CARS ON CREDIT',
  CIB: 'CIBC Auto Finance',
  CMS: 'CMSI',
  CRV: 'Credit River Capital Inc.',
  CVI: 'Credit Virage Canada',
  CRX: 'CreditMaxx Financing and Leasing Inc.',
  CDF: 'CU Dealer Finance',
  CXS: 'CU Dealer Finance Corp',
  CDL: 'CU Dealer Link',
  DAL: 'Davis Auto Leasing',
  DSJ: 'DESJARDINS',
  EDE: 'Eden Park Inc.',
  FEW: 'Finance West',
  FAP: 'First Access Funding Corp.',
  '1CS': 'First Calgary Savings',
  FOC: 'First Ontario Credit Union',
  GNB: 'General Bank',
  GGR: 'GGR Finance Inc.',
  FXC: 'GM Financial Lease',
  GMC: 'GM Financial Loan',
  GOA: 'Yes Plan Financial',
  HLC: 'Holand Leasing (1995) Ltd.',
  HYN: 'Kia Motors Finance',
  IAT: 'Industrial Alliance Trust Inc.',
  IAU: 'Industrial Alliance Trust Plus',
  LDC: 'LeaseDeal',
  LCR: 'Lendcare Capital Inc.',
  LGI: 'LGM Financial',
  LBR: 'Libro Financial Group',
  BNC: 'National Bank of Canada',
  NOL: 'No Preference',
  NOT: 'Northern Credit Union Limited',
  NSC: 'Northstar Acceptance Corp',
  OMI: 'OMISTA Credit Union Limited',
  PEN: 'PenFinancial',
  PFX: 'Pfaff Leasing',
  RFC: 'RIFCO',
  RBC: 'Royal Bank of Canada',
  TLC: 'Scotia Dealer Advantage',
  BNS: 'Scotiabank',
  CCS: 'Servus Credit Union',
  SON: 'Source One Financial Corp',
  SYH: 'Sym-Tech Financial Services',
  TDC: 'TD Auto Finance',
  TFX: 'Traction Financial',
  TFC: 'Travelers Financial Corporation',
  TAL: 'TREND Financial',
  TRI: 'Tricor Lease & Finance Corporation',
  WDR: 'Windsor Family Credit Union',
  WS1: 'WS Leasing',
  EP: 'EdenPark',
  '001': 'Honda Financial Services',
  '002': '1st Calgary',
  '003': 'Affinity Credit Union',
  '004': 'Conexus Credit Union',
  '005': 'Toyota Financial Services',
  '006': 'Ford Credit',
  '007': 'Honda Financial Services',
  '008': 'RYDE Financial Ltd',
  '009': 'FeLoans',
  '010': 'Harley-Davidson Financial Services',
  '011': 'Harley-Davidson Extended Service Plan',
  '012': 'Nissan Canada Finance',
  '013': 'Uni',
  '014': 'First West Credit Union',
  '015': 'Northern Credit Union',
  '016': 'Caisse Populaire Alliance',
  '017': 'Fairstone',
  '018': 'BMW Financial Services',
  '019': 'Financeit',
  '020': 'Assiniboine Credit Union',
  '021': 'Hyundai Finance',
  '022': 'LenderCorp',
  '023': 'Mercedes-Benz Financial Services',
  '024': 'Volkswagen Financial',
  '025': 'Prefera Finance',
  '026': 'Clear Financial',
  '027': 'Innovation Credit Union',
  '028': 'Santander',
  '029': 'Credit Acceptance Corp',
  '030': 'Ally',
  '031': 'Exeter Finance',
  '032': 'Global Lending Services',
  '033': 'Nissan Finance',
  '034': 'NMAC',
  '035': 'Subaru',
  '036': 'Chase',
  '037': 'Jackson River Credit Union',
  '038': 'DuPont Credit Union',
  '039': 'Capital One',
  '040': 'Member One Credit Union',
  '041': 'Wells Fargo',
};
